<template>
  <div id="right-3">
    <div class="area-title">
      <span>每日新增用户</span>
    </div>
    <div class="area-padding" ref="user_ref"></div>
  </div>
</template>
<script>
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      timer: null,
      config: {
        data: [],
        columnColor: "rgba(0, 194, 255, 0.4)",
        showValue: true,
      },
      userChart: null,
      xData: [],
      sData: [],
    };
  },
  mounted() {
    this.initChart();
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    // 初始化echarts实例对象
    initChart() {
      this.userChart = this.$echarts.init(this.$refs.user_ref);
    },
    // 获取服务器数据
    async getData() {
      // debugger;
      this.xData=[]
      this.sData=[]
      // 访问接口，获取数据，
      const { data: res } = await this.$http.get(
        "/admin/api/busi/stat/dailyNewUserNum",
        {
          params: {
            level: this.level,
            regionId: this.regionId,
            deviceType:0,
          },
        }
      );
      for (var i = 0; i < res.data.dailyNewUserNumVoList.length; i++) {
        this.xData.push(res.data.dailyNewUserNumVoList[i].dataDate);
        this.sData.push(res.data.dailyNewUserNumVoList[i].newUserTotal);
      }
      this.updateChart();
      // 启动定时器
      this.startInterval();
    },
    // 更新图表
    updateChart() {
      const option = {
        color: [
          // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#00FFC0", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#0050FF", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#F7B500", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#00FFBD", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        ],
        grid: {
          left: "10%",
          right: "7%",
          bottom: "15%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          data: this.xData,
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            color: "rgba(255,255,255,1)",
          },
        },
        yAxis: {
          splitLine: { show: false },
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
        },
        series: [
          {
            name: "hill",
            type: "pictorialBar",
            barCategoryGap: "-130%",
            symbol:
              "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
            itemStyle: {
              opacity: 0.5,
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
              opacity: 1,
              fontSize: 10,
              formatter: "{c}人",
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
              },
            },
            data: this.sData,
            // data: [454, 789, 564, 456, 788, 657, 456],
            z: 10,
            colorBy: "data",
          },
        ],
        // option结尾的大括号
      };
      this.userChart.setOption(option);
    },
    // 每隔3秒的定时器
    startInterval() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        this.sData = [];
        this.xData = [];
        this.getData();
      }, 1000 * 60 * 10);
    },
  },
};
</script>
<style lang="scss" scoped>
#right-3 {
  width: 100%;
  height: 288px;
  // border: 1px solid red;
  .area-title {
    width: 284px;
    height: 32px;
    background: url("../../assets/pgzl-ranking-bg.png");
    background-size: cover;
    background-position: center center;
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    span {
      margin-left: 40px;
    }
  }
  .area-padding {
    padding: 0 16px;
    width: 100%;
    height: 288px;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/right-3.vue